import type { AssessmentResponse, MaintenanceEvent } from '~/api/types'
import { AssessmentSideCard } from './assessment-side-card'
import { ChangeHistoryCard } from './change-history-card'

export function SidePanel({
    assessments,
    selectedAssessment,
    selectedId,
    onSelect,
    history,
    selectedEventId,
    onSelectEvent,
    onNewChange,
}: {
    assessments: AssessmentResponse[]
    selectedAssessment?: AssessmentResponse
    selectedId: string
    onSelect(value: string): void
    history: MaintenanceEvent[] | null
    selectedEventId: string | null
    onSelectEvent(value: string): void
    onNewChange(): void
}) {
    return (
        <aside className='flex min-h-0 flex-col gap-3 overflow-hidden max-xl:hidden'>
            <AssessmentSideCard
                assessments={assessments}
                selectedAssessment={selectedAssessment}
                selectedId={selectedId}
                onSelect={onSelect}
            />
            <ChangeHistoryCard
                history={history}
                selectedEventId={selectedEventId}
                onSelectEvent={onSelectEvent}
                onNewChange={onNewChange}
            />
        </aside>
    )
}
